
import React from 'react'
import {
    Box,
    // Button,
    Typography,
    // ToggleButton,
    // ToggleButtonGroup,
    // IconButton,
} from "@mui/material";
import FilesPic from "../assets/files.png";


function NoResourcesAvailable() {
    return (
        <Box
            sx={{
                padding: "5rem",
                paddingTop:"3rem"
                // height: "calc(100% - 10rem)",
            }}
        >
            <Box
                display={"flex"}
                // height={"100%"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Box
                    component="img"
                    src={FilesPic} // Replace this with the path to your image
                    alt="No files illustration"
                    sx={{ width: "200", maxWidth: "200px", marginBottom: "1rem" }}
                />
                <Typography
                    sx={{
                        fontSize: "18px",
                        textAlign: "center",
                    }}
                >
                    Oops! You don’t have any files.
                </Typography>
                <Typography
                    sx={{
                        fontSize: "12px",
                        textAlign: "center",
                        color: "#777"
                    }}
                >


                    When you add files, or files are shared with you, they will
                    appear here.
                </Typography>
            </Box>
        </Box>
    )
}

export default NoResourcesAvailable